<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Projects">
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-btn
              color="general"
              class="mb-2"
              @click="addItem()"
            >New Project</v-btn
            >
            <v-dialog
              v-model="dialogAdd"
              max-width="600px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="general" dark class="mb-2" v-on="on"
                  >New Device</v-btn
                >
              </template> -->
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <!-- <v-flex xs12 sm6 md4> -->
                      <v-text-field
                        v-model="addedItem.project"
                        required
                        label="Project Name (Required)"
                      />
                      <!-- </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeAdd">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="addProject">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogDelete"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to delete this project?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDelete"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="ProjectList"
              :search="search"
              class="elevation-1 devices-table"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.project }}</td>
                <td class="justify-center ">
                  <!-- <v-icon medium class="mr-2" @click="editItem(props.item)"
                    >edit</v-icon
                  > -->
                  <v-icon
                    medium
                    class="mr-2"
                    @click="deleteItem(props.item)"
                  >delete</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    max25chars: (v) => v.length <= 25 || 'Input too long!',
    pagination: {},
    ProjectList: [],
    rowsAmount: [
      10,
      15,
      20,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    dialogAdd: false,
    dialogDelete: false,
    search: '',
    headers: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'Project Name', value: 'project' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    deletedIndex: -1,
    deletedItem: {},
    addedIndex: -1,
    addedItem: {
      project: ''
    },
    defaultItem: {}
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogAdd (val) {
      val || this.closeAdd()
    }
  },
  // called when page is created before dom
  created () {
    this.getProjects()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    getProjects () {
      this.$http
        .get('projects')
        .then((response) => {
          this.ProjectList = response.data.projects
        })
        .catch((error) => console.log(error))
    },

    addItem () {
      this.dialogAdd = true
    },
    addProject () {
      if (this.addedItem.project == '' || this.addedItem.project == undefined) {
        this.requiredInline()
      } else {
        let objectForAddProject = {}
        objectForAddProject.project = this.addedItem.project

        let endpoint = `projects`
        let method = 'post'
        let tableItem = objectForAddProject
        this.$store
          .dispatch('addProject', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getProjects()
          })
          .catch((error) => {
            console.log(error)
            this.apiErrorInline()
          })

        this.closeAdd()
      }
    },

    deleteItem (item) {
      this.deletedIndex = this.ProjectList.indexOf(item)
      this.deletedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      let projectForDelete = {}
      projectForDelete.project = this.deletedItem.project

      let endpoint = `projects`
      let method = 'delete'
      let tableItem = projectForDelete
      this.$store
        .dispatch('deleteProject', { endpoint, tableItem, method })
        .then((response) => {
          this.ProjectList.splice(this.deletedIndex, 1)
          this.saveInline()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeDelete()
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem)
        this.deletedItem = -1
      })
    },

    closeAdd () {
      this.dialogAdd = false
      setTimeout(() => {
        this.addedItem = Object.assign({}, this.defaultItem)
        this.addedIndex = -1
      }, 300)
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Success'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    apiErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Something went wrong'
    },
    requiredInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Project Name is required'
    },
    reset () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'heron_info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.projects-table {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
